import { SENDER_STATUS_ACCEPTED, SENDER_STATUS_REJECTED, SENDER_STATUS_UNDECIDED } from './definitions';

export const senderStatusDisplayMap = {
    [null]: 'Uncertain',
    [SENDER_STATUS_ACCEPTED]: 'Verified',
    [SENDER_STATUS_REJECTED]: 'Rejected',
    [SENDER_STATUS_UNDECIDED]: 'Uncertain',
    [undefined]: 'Uncertain',
};

export const senderStatusSortValueMap = {
    [SENDER_STATUS_ACCEPTED]: -1,
    [SENDER_STATUS_REJECTED]: 2,
    [SENDER_STATUS_UNDECIDED]: 1,
};
